<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>课程介绍管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" class="user-search">
            <el-form-item label="视频介绍总开关">
                <el-switch
                    v-model="globalShowVideo"
                    :active-value="1"
                    :inactive-value="0"
                    active-text="显示"
                    inactive-text="隐藏"
                    @change="changeGlobalShowVideo">
                </el-switch>
            </el-form-item>


            <!-- <el-form-item>
        <el-select size="small" v-model="type" @change="selectSlideshow()" placeholder="请选择">
          <el-option v-for="type in typeArr" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item> -->



            <el-form-item label="">

                <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
            </el-form-item>
        </el-form>
        <!--列表-->
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
            element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column align="center" type="selection" width="60">
            </el-table-column>
            <el-table-column prop="name" label="主图" width="120">

                <template slot-scope="scope">
                    <img style="width: 90px;height: 90px;" :src="scope.row.coverPlan">
                </template>

            </el-table-column>
            <el-table-column sortable prop="title" label="标题" width="120"> </el-table-column>
            <el-table-column sortable prop="introduce" label="介绍" width="400"> </el-table-column>
            <el-table-column label="视频介绍" width="120">
                <template slot-scope="scope">
                    <el-tag size="small" :type="Number(scope.row.showVideo) === 0 ? 'info' : 'success'">
                        {{ Number(scope.row.showVideo) === 0 ? '隐藏' : '显示' }}
                    </el-tag>
                </template>
            </el-table-column>





            <el-table-column align="center" label="操作" min-width="300">
                <template slot-scope="scope">

                    <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger"
                        @click="deleteCourseIntroduce(scope.$index, scope.row)">删除</el-button>

                        <el-button size="mini" type="danger" @click="getCode(scope.$index, scope.row)">查看二维码</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="80%" @click="closeDialog">
            <el-form label-width="120px" ref="editForm">


                <el-form-item label="主图" style="">

                    <div class="upload-demo">
                        <el-upload action="" :http-request="mainImgUpload" :show-file-list="false"
                            list-type="picture-card">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                        <img v-if="formData.coverPlan" :src="formData.coverPlan" class="avatar">

                    </div>

                </el-form-item>


                <el-form-item label="标题" prop="title">
                    <el-input size="small" v-model="formData.title" auto-complete="off" placeholder="标题"></el-input>
                </el-form-item>

                <el-form-item label="介绍" prop="introduce">
                    <el-input size="small" v-model="formData.introduce" auto-complete="off" placeholder="介绍"></el-input>
                </el-form-item>




                <el-form-item label="视频" style="">

                    <div class="upload-demo">
                        <el-upload action="" :http-request="mainImgUpload2" :show-file-list="false"
                            list-type="picture-card">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </div>

                    <div>{{ formData.courseUrl }}</div>

                </el-form-item>

                <el-form-item label="图文" style="">

                    <quill-editor v-model="formData.text" :options="editorOption" style="height: 200px;"
                        ref="QuillEditor">
                    </quill-editor>

                </el-form-item>




            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="addCourseIntroduce()"
                    v-if="title == '添加'">添加</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="upCourseIntroduce()"
                    v-if="title == '修改'">修改</el-button>
            </div>
        </el-dialog>








    <!--    自定义上传组件-->
    <el-dialog
      title="选择图片"
      :visible.sync="uploadVisible"
      width="30%">
      <div>
        

           <div class="upload-demo">
                  <el-upload
                  action=""
                  :http-request="mainImgUpload3"
                  :show-file-list="false"
                  list-type="picture-card" >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <!-- <img v-if="formData.mainImg" :src="formData.mainImg" class="avatar"> -->
     
            </div>



      </div>

    </el-dialog>


    <!--    自定义上传组件-->
    <el-dialog
      title="二维码图片"
      :visible.sync="qrcodeUploadVisible"
      width="30%">


      <div style="width: 300px; height: 300px;">    <div  ref="qrcodejs2" ></div>  </div>

    </el-dialog>




    </div>
</template>

<script>
import {

    addCourseIntroduce,
    upCourseIntroduce,
    deleteCourseIntroduce,
    getCourseIntroduceList,
    getCourseIntroduceShowConfig,
    upCourseIntroduceShowConfig,





} from "../../api/userMG";
import Pagination from "../../components/Pagination";
import client from "@/utils/ossClient.js";




// 引入 qrcodejs2
import QRCode from 'qrcodejs2';


import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

// 工具栏配置
const toolbarOptions = [
    ["bold", "italic", "underline", "strike"], // toggled buttons
    ["blockquote", "code-block"],

    [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: "ordered" }, { list: "bullet" }],
    [{ script: "sub" }, { script: "super" }], // superscript/subscript
    [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
    [{ direction: "rtl" }], // text direction

    [{ size: ["small", false, "large", "huge"] }], // custom dropdown
    [{ header: [1, 2, 3, 4, 5, 6, false] }],

    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    [{ font: [] }],
    [{ align: [] }],
    ["link", "image", "video"], // 对于图片上传这是重点
    ["clean"], // remove formatting button
];



export default {
    data() {
        return {
            qrcodeUploadVisible:false,


            cursorIndex: 0,
            editorOption: {
                modules: {
                    toolbar: {
                        container: toolbarOptions, // 工具栏
                        handlers: {
                            image: (value) => {
                                if (value) {
                                    // 在这里编写图片按钮点击操作
                                    this.uploadVisible = true;
                                    this.cursorIndex =
                                        this.$refs.QuillEditor.quill.getSelection().index;
                                } else {
                                    this.quill.format("image", false);
                                }
                            },
                        },
                    },
                },
            },
            uploadVisible: false,



            type: 0,
            typeArr: [
                { key: '视频区域', value: 0 },
                { key: '直播区域', value: 1 },
                { key: '首页', value: 2 }
            ],
            isData: false,
            nshow: true, //switch开启
            fshow: false, //switch关闭
            loading: false, //是显示加载
            editFormVisible: false, //控制编辑页面显示与隐藏
            editFormVisibleData: false,
            title: "添加",
            globalShowVideo: 0,
            globalShowVideoLoading: false,

            listData: [], //
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 20,
                total: 10,
            },


            formData: {
                coverPlan: "",
                title: "",
                introduce: "",
                text: "",
                courseUrl: "0",
            },




        };
    },
    // 注册组件
    components: {
        Pagination,
        VueQuillEditor
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
        this.getCourseIntroduceShowConfig()
        this.getCourseIntroduceList()

    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
        getCourseIntroduceShowConfig() {
            getCourseIntroduceShowConfig().then((res) => {
                if (res.code == 200) {
                    this.globalShowVideo = Number(res.data.showVideo) === 0 ? 0 : 1;
                    return;
                }
                this.$message.error(res.msg);
            });
        },
        changeGlobalShowVideo(value) {
            if (this.globalShowVideoLoading) {
                return;
            }
            this.globalShowVideoLoading = true;
            upCourseIntroduceShowConfig({
                showVideo: value
            }).then((res) => {
                this.globalShowVideoLoading = false;
                if (res.code == 200) {
                    this.globalShowVideo = Number(res.data.showVideo) === 0 ? 0 : 1;
                    this.$message.success('总开关已更新');
                    this.getCourseIntroduceList();
                    return;
                }
                this.$message.error(res.msg);
                this.getCourseIntroduceShowConfig();
            }).catch(() => {
                this.globalShowVideoLoading = false;
                this.$message.error('总开关更新失败，请稍后再试');
                this.getCourseIntroduceShowConfig();
            });
        },


        getCode(index,item){

            console.log(123,item)
            console.log(QRCode)
            this.qrcodeUploadVisible = true;

            var self = this;



            setTimeout(() => {
            

                        // 创建二维码
            self.qrcode = new QRCode(self.$refs.qrcodejs2, {
                text: 'https://smilingly.huike996.com/#/pages/courseCode/courseCode?id='+item.id,
                width: 150,
                height: 150
            })


            }, 300);

            },



        //自定义上传方法..
        mainImgUpload2(file) {

            //判断扩展名
            const tmpcnt = file.file.name.lastIndexOf(".");
            const exname = file.file.name.substring(tmpcnt + 1);
            // const names = ["jpg", "jpeg", "webp", "png", "bmp"];
            // if (names.indexOf(exname) < 0) {
            //   this.$message.error("不支持的格式!");
            //   return;
            // }


            const fileName = file.file.uid + "." + exname;
            client
                .put(fileName, file.file)
                .then((res) => {
                    console.log(res)
                    if (res.url) {

                        this.formDataData.courseUrl = res.url;

                        this.formDataData = JSON.parse(JSON.stringify(this.formDataData))

                    } else {
                        this.$message.error("文件上传失败");
                    }
                })
                .catch((err) => { });
        },




        //自定义上传方法..
        mainImgUpload3(file) {
            var self = this;
            //判断扩展名
            const tmpcnt = file.file.name.lastIndexOf(".");
            const exname = file.file.name.substring(tmpcnt + 1);
            // const names = ["jpg", "jpeg", "webp", "png", "bmp"];
            // if (names.indexOf(exname) < 0) {
            //   this.$message.error("不支持的格式!");
            //   return;
            // }
            const fileName = file.file.uid + "." + exname;
            client
                .put(fileName, file.file)
                .then((res) => {
                    if (res.url) {
                        console.log("2222222", res);
                        self.getUrl(res.url);
                    } else {
                        this.$message.error("文件上传失败");
                    }
                })
                .catch((err) => { });
        },


        getUrl(url) {
            this.uploadVisible = false;
            // 获取富文本组件实例
            let quill = this.$refs.QuillEditor.quill;
            // 如果上传成功
            if (url) {
                // 插入图片，res为服务器返回的图片链接地址

                quill.insertEmbed(this.cursorIndex, "image", url);
                // 调整光标到最后
                quill.setSelection(this.cursorIndex + 1);
            } else {
                // 提示上传失败信息
            }
        },




        // 删除
        deleteCourseIntroduce(index, row) {
            this.$confirm("确定要删除吗?", "信息", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteCourseIntroduce({ id: row.id })
                        .then((res) => {
                            if (res.code == 200) {
                                this.$message({
                                    type: "success",
                                    message: "已删除！",
                                });
                                this.getCourseIntroduceList();
                            } else {
                                this.$message({
                                    type: "info",
                                    message: res.msg,
                                });
                            }
                        })
                        .catch((err) => {
                            this.loading = false;
                            this.$message.error("删除失败，请稍后再试！");
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },

        //修改轮播图
        upCourseIntroduce() {

            this.loading = true;
            var formData = JSON.parse(JSON.stringify(this.formData));


            upCourseIntroduce(formData).then((res) => {
                this.loading = false;
                if (res.code == 200) {
                    this.editFormVisible = false
                    this.$message({
                        type: "success",
                        message: res.msg,
                    });
                    this.getCourseIntroduceList();
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        //添加轮播图
        addCourseIntroduce() {

            this.loading = true;

            var formData = JSON.parse(JSON.stringify(this.formData))




            addCourseIntroduce(this.formData).then((res) => {
                this.loading = false;
                if (res.code == 200) {
                    this.editFormVisible = false
                    this.$message({
                        type: "success",
                        message: res.msg,
                    });
                    this.getCourseIntroduceList();
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        //自定义上传方法..
        mainImgUpload(file) {

            //判断扩展名
            const tmpcnt = file.file.name.lastIndexOf(".");
            const exname = file.file.name.substring(tmpcnt + 1);
            // const names = ["jpg", "jpeg", "webp", "png", "bmp"];
            // if (names.indexOf(exname) < 0) {
            //   this.$message.error("不支持的格式!");
            //   return;
            // }
            const fileName = file.file.uid + "." + exname;
            client
                .put(fileName, file.file)
                .then((res) => {
                    if (res.url) {

                        this.formData.coverPlan = res.url;
                    } else {
                        this.$message.error("文件上传失败");
                    }
                })
                .catch((err) => { });
        },


        // 获取轮播图
        getCourseIntroduceList() {
            this.loading = true;

            getCourseIntroduceList().then((res) => {
                this.loading = false;
                if (res.code == 200) {
                    this.listData = res.data.list;
                    return;
                }
                this.$message({
                    type: "info",
                    message: res.msg,
                });
            });
        },

        // 分页插件事件
        callFather(parm) {
            this.getDishesList(parm.currentPage);
        },

        //显示编辑界面
        handleEdit: function (index, row) {
            this.editFormVisible = true;
            if (row != undefined && row != "undefined") {
                this.title = "修改";
                this.formData.id = row.id;
                this.formData.coverPlan = row.coverPlan;
                this.formData.title = row.title;
                this.formData.introduce = row.introduce;
                this.formData.text = row.text;
                this.formData.courseUrl = row.courseUrl;

            } else {
                this.title = "添加";
                this.formData.id = "";
                this.formData.coverPlan = "";
                this.formData.title = "";
                this.formData.introduce = "";
                this.formData.text = "";
                this.formData.courseUrl = "";
            }




        },

        // 关闭编辑、增加弹出框
        closeDialog() {
            this.editFormVisible = false;
        },























    },
};
</script>

<style scoped>
.user-search {
    margin-top: 20px;
}

.userRole {
    width: 100%;
}

.upload-demo {
    display: flex;
    flex-direction: row;
}

.upload-demo img {
    width: 140px;
    height: 140px;
}
</style>



// WEBPACK FOOTER //
// src/views/teacher/Introduce.vue